// Service API pour communication avec le backend
import axios from 'axios';
import { isElectron } from '../utils/electron';

// URL du serveur backend de production
const PRODUCTION_API_URL = 'https://golden-mali.cloud/api';

// Fonction pour obtenir l'URL API au runtime (appelée à chaque requête)
const getApiBaseUrl = () => {
  // Si on est dans Electron, se connecter directement au serveur backend de production
  if (isElectron()) {
    return PRODUCTION_API_URL;
  }
  
  // Détection au runtime (après chargement de la page) pour le navigateur
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    // Seulement si vraiment localhost en développement
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3001/api';
    }
  }
  // PRODUCTION WEB : TOUJOURS /api (même serveur)
  return '/api';
};

// Créer l'instance axios avec /api par défaut (production)
const api = axios.create({
  baseURL: '/api', // PAR DÉFAUT : /api pour la production
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour définir l'URL correcte à chaque requête (RUNTIME GARANTI)
api.interceptors.request.use(
  (config) => {
    // Définir l'URL au moment de la requête (runtime garanti)
    const correctBaseURL = getApiBaseUrl();
    config.baseURL = correctBaseURL;
    
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // En mode offline, ne pas rejeter les erreurs réseau
    if (!navigator.onLine && (!error.response || error.code === 'ERR_NETWORK')) {
      // Retourner une erreur spéciale pour le mode offline
      const offlineError = new Error('Mode offline');
      offlineError.isOffline = true;
      return Promise.reject(offlineError);
    }

    if (error.response?.status === 401) {
      // Ne pas rediriger si c'est la requête de LOGIN qui a échoué (mauvais identifiants)
      const isLoginRequest = (error.config?.url === '/auth/login' || error.config?.url?.includes('auth/login')) && (error.config?.method === 'post' || error.config?.method === 'POST');
      if (!isLoginRequest) {
        localStorage.removeItem('authToken');
        if (navigator.onLine) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
